import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import type { FaqCategory } from 'modules/TheHulk/TheHulk.types'
import type { ReactElement } from 'react'

export interface FaqCategoriesProps {
  readonly faqCategories: FaqCategory[] | null
  readonly onAction: (category: FaqCategory) => void
}

const FaqCategoryCard = ({
  faqCategories,
  onAction,
}: FaqCategoriesProps): ReactElement => (
  <Grid
    container
    spacing={3}
    sx={{
      padding: 2,
    }}
  >
    {faqCategories?.map((category) => (
      <Grid key={category.key} size={6}>
        <Card variant="outlined">
          <CardActionArea onClick={() => onAction(category)}>
            <CardContent>
              <Typography variant="h6" color="primary.main">
                {category.name}
              </Typography>
              <Typography variant="p3" color="primary.main">
                {category.description}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>
    ))}
  </Grid>
)

export default FaqCategoryCard
